import React from "react";
import AftersaleSearchForm from 'containers/aftersale/aftersaleSearch';
import AftersaleEdit from 'containers/aftersale/aftersaleEdit';
import axios from 'axios';

import { Table, Tag, Typography, Button, Layout, Row, Col, Divider, Spin, Space, Popconfirm, message, Form, Input } from 'antd';
import {
    EyeOutlined,
    EditOutlined,
    CheckCircleOutlined,
    SyncOutlined,
    CloseCircleOutlined
} from '@ant-design/icons';
import { Link } from "react-router-dom";

const { Content } = Layout;
const { Title } = Typography;

export default class MemberList extends React.Component {

    constructor(props: any) {
        super(props);
        this.getMembers();
    }

    state = {
        memberData: [],
        userInfo: [],
        loading: true,
        total: 0,
        dataId: 0,
        editorVisible: false,
        editorTitle: "Modal Title"
    };

    getMembers = () => {
        axios.get('https://www.fastmock.site/mock/9973669a2a13cbb70690fdf6f1880e97/admin/aftersale/list', {
            params: {}
        })
            .then((res) => {
                console.log('res', res.data.data.list)
                this.setState({
                    memberData: res.data.data.list,
                    total: res.data.data.total,
                    loading: false
                })
            })
            .catch((err) => {
                console.log(err)
            })
    }

    columns = [
        {
            title: '状态',
            dataIndex: 'status',
            width: '110px',
            render: (text: any) => {
                if (text == 0) {
                    return (
                        <Tag icon={<SyncOutlined spin />} color="processing">
                            处理中
                        </Tag>
                    );
                } else if (text == 1) {
                    return (
                        <Tag icon={<CheckCircleOutlined />} color="success">
                            已同意
                        </Tag>
                    );
                } else if (text == 2) {
                    return (
                        <Tag icon={<CloseCircleOutlined />} color="error">
                            已拒绝
                        </Tag>
                    )
                }
            }
        },
        {
            title: '申请种类',
            dataIndex: 'type',
            width: '7%'
        },
        {
            title: '商品？订单',
            dataIndex: 'productName',
            width: '15%'
        },
        {
            title: '申请人',
            dataIndex: 'nickName',
            width: '8%',
            render: (text: any, record: any) =>
                <div>
                    {text}<br />{record.phoneNumber}
                </div>
        },
        {
            title: '金额',
            dataIndex: 'amount',
            width: '6%'
        },
        {
            title: '原因分类',
            dataIndex: 'reasonCategory',
            width: '10%'
        },
        {
            title: '原因',
            dataIndex: 'reason'
        },
        {
            title: '描述',
            dataIndex: 'desc',
            ellipsis: true
        },
        {
            title: '申请时间',
            dataIndex: 'applyTime',
        },
        {
            title: '操作',
            dataIndex: 'id',
            render: (text: number, record: any) => {
                if (record.status == 0) {
                    return (
                        <Button type="primary" shape="round" onClick={this.editData.bind(this, text)}><EditOutlined />编辑</Button>
                    )
                } else {
                    return (
                        <Button shape="round" onClick={this.editData.bind(this, text)}><EyeOutlined />查看</Button>
                    )
                }
            }
        }
    ];

    cancelModal = () => {
        this.setState({
            editorVisible: false,
        });
    };

    createData = () => {
        this.setState({
            editorVisible: true,
            editorTitle: "新增售后"
        });
    };

    editData = (text: number): any => {
        this.setState({
            dataId: text,
            editorVisible: true,
            editorTitle: "编辑售后 ID - " + text.toString()
        });
    }

    deleteConfirm = (text: number): any => {
        message.warning("删除了id" + text.toString());
    }

    render() {
        let userInfo: any = this.state.userInfo;
        return (
            <div>
                <div className="page-title">
                    <Title level={3}>售后订单</Title>
                </div>

                <Divider />

                <Row gutter={[18, 18]}>
                    <Col>
                        <AftersaleSearchForm />
                    </Col>
                </Row>
                <Spin tip="Loading..." size="large" spinning={this.state.loading}>
                    <Table
                        columns={this.columns}
                        dataSource={this.state.memberData}
                        pagination={{
                            total: this.state.total,
                            position: ["bottomLeft"],
                        }}
                    />
                </Spin>
                <AftersaleEdit dataId={this.state.dataId} editorVisible={this.state.editorVisible} editorTitle={this.state.editorTitle} onCancel={this.cancelModal} ref="child" />
            </div>
        );
    }
}
